module.exports = __webpack_public_path__ + "img/discover.99739a39.png";